import { useQuery } from '@tanstack/react-query';
import { getFees } from '@/api/getFees';
import getSkuBidsAsks from '@/api/getSkuBidsAsks';
import getSkuId from '@/api/getSkuId';

function useFetchFees(spiritoryBottle: boolean = false) {
  const data = useQuery({
    queryKey: ['user/fees'],
    queryFn: getFees,
  });

  if (spiritoryBottle) {
    return {
      data: {
        id: 1,
        name: 'Zero fees',
        buyerCommissionFeePercent: 0,
        buyerShippingFeeFixed: 0,
        created: new Date(),
        salesTaxPercent: 19,
        sellerCommissionFeePercent: 0,
        sellerPaymentProcessingFeePercent: 0,
      },
    };
  }

  return data;
}

function useFetchBidsAsks(slug: string) {
  const data = useQuery({
    queryKey: ['sku/bids-asks', slug],
    queryFn: ({ queryKey }) => getSkuBidsAsks(queryKey[1]),
  });

  return data;
}

function useFetchSkuId(slug: string) {
  const data = useQuery({
    queryKey: ['sku/id', slug],
    queryFn: ({ queryKey }) => getSkuId(queryKey[1]),
  });

  return data;
}

export { useFetchFees, useFetchBidsAsks, useFetchSkuId };
